import { Component, ViewChild, OnInit } from "@angular/core";
import { SujetoObligadoDialogBoxComponent } from "./dialog/sujeto-obligado-dialog-box.component";
import { MatTable } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { first } from "rxjs/operators";
import { SujetoObligadoService } from "../../../services/sujeto-obligado.service";
import { SujetoObligado } from "app/main/models/sujeto-obligado.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatPaginator, PageEvent } from "@angular/material/paginator";

import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { threadId } from "worker_threads";
import { Router } from "@angular/router";

/*
export interface UsersData {
  nombre: string;
  apellido: string;
  imagen: string;
  correoElectronico: string;
  password: string;
  active: number;
  tipo: any;
  id: number;
}*/

const ELEMENT_DATA: SujetoObligado[] = [];

@Component({
    selector: "sujetos-obligados",
    templateUrl: "./sujetos-obligados.component.html",
    styleUrls: ["./sujetos-obligados.component.scss"],
})
export class SujetoObligadoComponent {
    displayedColumns: string[] = [
        "nombre",
        "razonSocial",
        "tipoSujetoObligado",
        "action",
    ];
    dataSource = ELEMENT_DATA;
    roles = [];
    basicSlice = 10;
    usersCount = 0;
    pageSlice = [];

    @ViewChild(MatTable, { static: true }) table: MatTable<any>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    constructor(
        public dialog: MatDialog,
        private _fuseProgressBarService: FuseProgressBarService,
        private _snackBar: MatSnackBar,
        public router: Router,
        private sujetosObligadosService: SujetoObligadoService
    ) {}

    ngOnInit() {
        this.paginator._intl.itemsPerPageLabel = "Ítems por página";
        this.sujetosObligadosService.count().subscribe((req) => {
            this.usersCount = req.body;
        });
        this.getUsersPaginator(0);
    }

    getUsersPaginator(page): void {
        this.sujetosObligadosService
            .getAll(page, this.basicSlice)
            .pipe()
            .subscribe((req) => {
                this.dataSource = req.body.map((so) => {
                    console.log(so);
                    return {
                        id: so.id,
                        nombre: so.nombre,
                        apellido: so.apellido,
                        nombreCompleto: so.nombreCompleto,
                        correoElectronico: so.correoElectronico,
                        contacto: so.contacto,
                        tipos: so.tipos,
                        estructuras: so.estructuras,
                        active: so.active,
                        evaluaciones: so.evaluaciones,
                        razonSocial: so.razonSocial,
                        tipo: so.tipo,
                        sectorIndustrial: so.sectorIndustrial,
                        externalId: so.externalId,
                        descripicion: so.descripcion,
                        sectorIdustrial: so.sectorIndustrial,
                        tipoSujetoObligado: so.tipoSujetoObligado,
                    };
                });
            });
    }

    openDialog(action, obj): void {
        obj.action = action;
        const dialogRef = this.dialog.open(SujetoObligadoDialogBoxComponent, {
            width: "100%",
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === "Add") {
                this.addRowData(result.data);
            } else if (result.event === "Update") {
                this.updateRowData(result.data);
            } else if (result.event === "Delete") {
                this.deleteRowData(result.data);
            }
        });
    }

    addRowData(row_obj): void {
        console.log("Im here");
        this.sujetosObligadosService
            .register(row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.dataSource.push({
                        id: data.body.id,
                        nombre: data.body.nombre,
                        apellido: data.body.apellido,
                        nombreCompleto: data.body.nombreCompleto,
                        //sectorIndustrial: data.body.sectorIndustrial,
                        tipoSujetoObligado: data.body.tipoSujetoObligado,
                        nombreFiscal: data.body.nombreFiscal,
                        correoElectronico: data.body.correoElectronico,
                        tipo: data.body.tipo,
                        active: data.body.active,
                        razonSocial: data.body.razonSocial,
                        direccionFisica: data.body.direccionFisica,
                        direccionFiscal: data.body.direccionFiscal,
                        telefono: data.body.telefono,
                        representantes: data.body.representantes,
                        clientes: data.body.clientes,
                        externalId: data.body.externalId,
                        descripcion: data.body.descripcion,
                    });
                    //this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);

                    this.openSnackBar(
                        "Se ingresó el sujeto obligado correctamente.",
                        "Cerrar"
                    );
                    this.dataSource.sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                    );
                    this.table.renderRows();
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo ingresar el sujeto obligado, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    updateRowData(row_obj): void {
        this.sujetosObligadosService
            .edit(row_obj.id, row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.dataSource = this.dataSource.filter((value, key) => {
                        if (value.id === row_obj.id) {
                            value.id = row_obj.id;
                            value.nombre = row_obj.nombre;
                            value.apellido = row_obj.apellido;
                            value.nombreCompleto = row_obj.nombreCompleto;
                            value.nombreFiscal = row_obj.nombreFiscal;
                            value.active = row_obj.active;
                            value.correoElectronico = row_obj.correoElectronico;
                            value.tipo = row_obj.tipo;
                            value.razonSocial = row_obj.razonSocial;
                            (value.direccionFisica = row_obj.direccionFisica),
                                (value.direccionFiscal =
                                    row_obj.direccionFiscal),
                                (value.telefono = row_obj.telefono),
                                (value.representantes = row_obj.representantes),
                                (value.clientes = row_obj.clientes);
                        }
                        return true;
                    });
                    this.dataSource = [...this.dataSource];
                    this.ngOnInit();
                    //this.dataSource.sort((a, b) => (a.correoElectronico > b.correoElectronico) ? 1 : -1);
                    this.openSnackBar(
                        "Se actualizó el sujeto obligado correctamente.",
                        "Cerrar"
                    );
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo actualizar el sujeto obligado, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    deleteRowData(row_obj): void {
        this.sujetosObligadosService
            .delete(row_obj.id)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.dataSource = this.dataSource.filter((value, key) => {
                        return value.id !== row_obj.id;
                    });

                    this.openSnackBar(
                        "Se elimino el sujeto obligado correctamente.",
                        "Cerrar"
                    );
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo eliminar el sujeto obligado, esta asociado a otra entidad.",
                        "Cerrar"
                    );
                }
            );
    }

    OnePageChange(event: PageEvent) {
        this.basicSlice = event.pageSize;
        this.getUsersPaginator(event.pageIndex);
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }

    navegateTo(url, id): void {
        this.router.navigate([url, id]).then((e) => {
            if (e) {
                console.log("Navigation is successful!");
            } else {
                console.log("Navigation has failed!");
            }
        });
    }
}
